import { SwiperOptions } from './types';

type Swiper = import('swiper').default;

export function parallax(offset = 0.5, bgSelector = '.default-slide__bg'): SwiperOptions {
    return {
        speed: 600,
        spaceBetween: 0,
        watchSlidesProgress: true,
        on: {
            progress(this: Swiper) {
                const swiper = this;

                for (let i = 0; i < swiper.slides.length; i++) {
                    const slideProgress = swiper.slides[i].progress;
                    const innerOffset = swiper.width * offset;
                    const innerTranslate = slideProgress * innerOffset;
                    swiper.slides[i].querySelector(
                        bgSelector
                    ).style.transform = `translate3d(${innerTranslate}px, 0, 0)`;
                }
            },
            touchStart(this: Swiper) {
                const swiper = this;

                for (let i = 0; i < swiper.slides.length; i++) {
                    swiper.slides[i].style.transition = null;
                }
            },
            setTransition(this: Swiper, speed: any) {
                const swiper = this;

                for (let i = 0; i < swiper.slides.length; i++) {
                    swiper.slides[i].style.transition = `${speed}ms`;
                    swiper.slides[i].querySelector(
                        bgSelector
                    ).style.transition = `${speed}ms`;
                }
            },
        },
    };
}
